import React from "react";

export default function CoachReviewModal({ open, review, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-lg w-full relative flex flex-col max-h-[85vh]">
        <div className="flex items-start justify-between p-6 pb-4 border-b border-gray-200">
          <h2 className="text-lg font-bold">Grr Review</h2>
          <button
            className="text-gray-500 hover:text-gray-700 text-xl font-bold leading-none -mt-1"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          {review ? (
            <div className="flex flex-col gap-5 text-sm">
              {review.contentRating && (
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold border border-gray-300 rounded px-2 py-1 text-gray-600">
                    {review.contentRating}
                  </span>
                  <span className="text-xs uppercase tracking-wide text-gray-400 font-semibold">Rating</span>
                </div>
              )}
              {review.bestPart && (
                <div className="rounded-md border-l-4 border-emerald-400 bg-emerald-50 p-3">
                  <h3 className="text-sm text-emerald-800 font-semibold mb-1">
                    Best Part
                  </h3>
                  <p className="text-emerald-900 leading-relaxed">{review.bestPart}</p>
                </div>
              )}
              {review.needsImprovement && (
                <div className="rounded-md border-l-4 border-amber-400 bg-amber-50 p-3">
                  <h3 className="text-sm text-amber-800 font-semibold mb-1">
                    Areas for Improvement
                  </h3>
                  <p className="text-amber-900 leading-relaxed">{review.needsImprovement}</p>
                </div>
              )}
              <div>
                <span className="text-xs uppercase tracking-wide text-gray-400 font-semibold">Laughs</span>
                <div className="flex gap-6 mt-1">
                  <div>
                    <span className="text-2xl font-bold text-gray-800">{review.okLaughs}</span>
                    <span className="block text-xs text-gray-400">OK</span>
                  </div>
                  <div>
                    <span className="text-2xl font-bold text-gray-800">{review.goodLaughs}</span>
                    <span className="block text-xs text-gray-400">Good</span>
                  </div>
                  <div>
                    <span className="text-2xl font-bold text-gray-800">{review.greatLaughs}</span>
                    <span className="block text-xs text-gray-400">Great</span>
                  </div>
                </div>
              </div>
              {review.confusingPart && (
                <div className="rounded-md border-l-4 border-rose-400 bg-rose-50 p-3">
                  <h3 className="text-sm text-rose-800 font-semibold mb-1">
                    Confusing Part
                  </h3>
                  <p className="text-rose-900 leading-relaxed">{review.confusingPart}</p>
                </div>
              )}
            </div>
          ) : (
            <div className="text-gray-500">No review available.</div>
          )}
        </div>

        <div className="flex justify-end gap-2 p-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="bg-gray-800 text-white font-semibold py-2 px-5 rounded-lg hover:bg-gray-700 transition"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
